import { getDownloadDocumentUrl } from "@/services/api";
import { useEffect, useState } from "react";

type DocumentDownloadType = {
    closeRequest: Function;
    documentId: number;
    isGlobalDocument?: boolean;
    customUrl?: string;
}

const DocumentDownload = ({closeRequest, documentId, isGlobalDocument = false, customUrl}: DocumentDownloadType) => {
    const [documentDownloadUrl, setDocumentDownloadUrl] = useState<string>(customUrl ?? getDownloadDocumentUrl(documentId, isGlobalDocument));
    const [intervalId, setIntervalId] = useState<NodeJS.Timer>();
  
    // useEffect(() => {
    //     if (documentDownloadUrl) {
    //         let frame = document.querySelector<HTMLIFrameElement>('#my_iframe');
    //         const newInterval = setInterval(() => {
    //             // console.log(frame?.contentWindow?.document.body);
    //             if (frame?.contentWindow?.document.body.innerHTML) {
    //                 clearInterval(intervalId);
    //                 setIntervalId(undefined);
    //                 closeRequest();
    //             }
    //         },200);
    //         setIntervalId(newInterval);
    //     } else {
    //         let frame = document.querySelector<HTMLIFrameElement>('#my_iframe');
    //         console.log(frame?.contentWindow?.document.body);
    //         clearInterval(intervalId);
    //         setIntervalId(undefined);
    //     }
    // }, [documentDownloadUrl])

    // const downloadDocument = () => {
    //     //getDownloadDocument(currentDocument!.id).then((data) => {
    //     //    var saveByteArray = (function () {
    //     //        var a = document.createElement("a");
    //     //        document.body.appendChild(a);
    //     //        a.setAttribute("style","display: none");
    //     //        return function (data: any, name: any) {
    //     //            var blob = new Blob(data, {type: "octet/stream"}),
    //     //                url = window.URL.createObjectURL(blob);
    //     //            a.href = url;
    //     //            a.download = name;
    //     //            a.click();
    //     //            window.URL.revokeObjectURL(url);
    //     //        };
    //     //    }());
    //     //    saveByteArray([data], currentDocument.fileName);
    //     //})
    // }

    useEffect(() => {
        var timer = setInterval(function () {
            var iframe = document.getElementById('my_iframe');
            var iframeDoc = iframe?.ownerDocument;
          
            if (iframeDoc?.readyState == 'complete' || iframeDoc?.readyState == 'interactive') {
                clearInterval(timer);
                closeRequest();
                return;
            }
        }, 1000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<>{documentDownloadUrl && <iframe id="my_iframe" className="c-documents-preview-hidden-iframe" src={getDownloadDocumentUrl(documentId, isGlobalDocument)}></iframe>}</>)
}

export default DocumentDownload